import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import RouteHandler from "./RouteHandler";
import { MsalProvider } from "@azure/msal-react";

const App = ({ instance }) => {
  console.log("NODE", process.env.NODE_ENV);
  console.log("RUN", process.env.REACT_APP_RUN_ENV);
  return (
    <>
      <Router>
        <MsalProvider instance={instance}>
          <Suspense fallback={<div>Loading.....</div>}>
            <RouteHandler />
          </Suspense>
        </MsalProvider>
      </Router>
    </>
  );
};
export default App;
